module.exports = __webpack_public_path__ + "img/internet.e4f0386e.webp";